$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  updateSignupFeature();
  logoAnimation();
  contentMargin();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// custom header logo animation
function logoAnimation() {
  $('.header-logo').append('<div class="animation-logo"></div>');
}

// --------------------------------
// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// --------------------------------
// Custom  signup widget
function updateSignupFeature() {
  const containerSectionClass = 'footer';

  const signupTitle = `
  <span>Celebrate Saint Paul’s</span>
  <span>Coolest Season</span>`;
  const signupText = `<span>Join Our Email Newsletter!</span>`;
  const inputPlaceholder = 'Email Address';
  const buttonLabel = 'Sign Up';

  const $signupElement = $(`.${containerSectionClass} .emailSignup`);
  const $signupText = $signupElement.find('.emailSignupText');

  $signupText.replaceWith(`
    <div class="signup-text">
      <h2 class="signup-title">${signupTitle}</h2>
      <p class="signup-description">${signupText}</p>
    </div>
    `);

  $signupElement
    .find('.emailInputField, .emailInputSubmit')
    .wrapAll('<div class="input-container"></div>');
  $signupElement.find('.emailInputField input').val('').attr('placeholder', inputPlaceholder);
  $signupElement.find('.emailInputSubmit a').text(buttonLabel);
}

// --------------------------------
// --------------------------------
// function to validate external Links
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(window).width() <= breakpoint;
}

// --------------------------------
// --------------------------------
// Resizing and content margin
function contentMargin() {
  function applyMarginTop() {
    const $content = $('.content');
    const isHomepage = $('body').hasClass('homepage');
    const isScroll = $('body').hasClass('saffireWindowScrolled');
    const isMobile = validateWindowSize(1040);
    const height = $('.header').height();

    let marginTop = 0;

    if (!isMobile) {
      if (isHomepage) {
        marginTop = height;
      } else if (isScroll) {
        marginTop = height + 140;
      } else {
        marginTop = height + 100;
      }
    } else {
      marginTop = isHomepage ? 0 : 20;
    }

    $content.css('margin-top', marginTop + 'px');
  }

  $(document).ready(applyMarginTop);
  $(window).on('load resize', applyMarginTop);
  new ResizeObserver(applyMarginTop).observe(document.querySelector('.header'));
}
